/**
 * Created by eliana.centamore on 28/12/2020
 */

"use strict";

var ConcurrentUsers = {

    mappingRequestedPage: {
        'institutions': 'search_institutions',
        'institution_details': {
            'institution_profile': 'institutions_institution_profile',
            'payment_data': 'institutions_payment_data',
            'routing_data': 'institutions_payment_data',
            'ssi': 'institutions_payment_data',
            'operational_structure': 'institutions_payment_data',
            'bic_events': 'institutions_bic_events',
            'broadcasts_news': 'institutions_broadcasts_news',
            'due_diligence': 'institutions_due_diligence',
            'financial_data': 'institutions_due_diligence',
            'credit_ratings': 'institutions_due_diligence',
            'share_holding': 'institutions_due_diligence',
            'legal_hierarchy': 'institutions_due_diligence',
            'people': 'institutions_due_diligence',
        },
        'ssis': 'search_ssis',
        'ssis_details': 'ssis_details',
        'payment_systems': 'search_payment_systems',
        'payment_systems_details': 'payment_systems_details',
        'broadcasts_news': 'search_broadcasts_news',
        'countries_currencies': 'cch_countries_currencies',
        'iban_validation': 'iban_validation',
        'iban_structure': 'iban_structure',
        'iban_constructor': 'iban_constructor'
    },

    check: function (event, requestedPage, callback, DOMElement) {
        var self = this;
        var url = window.Swiftref.base_url + "/concurrent_users/check?requested_page=" + requestedPage;

        $.get(url, function (data) {
            if (data && data.hasOwnProperty('concurrent_user_allowed') && data.concurrent_user_allowed == false) {

                self.notify();

                if (event) {

                    // return to the previous tab (CURRENTLY USED ON INSTITUTION DETAILS)
                    if ($(".not_allowed")[0]) {
                        $(".not_allowed").removeClass("not_allowed");
                    }


                    event.target.classList.add("not_allowed");

                    if (document.querySelector(".allowed") !== null) {
                        document.querySelector(".allowed").click();
                    }
                }
                // do somenthing in case of user not allowed: for e.g. hide partial
                callback();

            } else {
                self.hide();

                if ($(".allowed")[0]) {
                    $(".allowed").removeClass("allowed");
                }


                if (event) {
                    event.target.classList.add("allowed");
                }

                if (DOMElement && $(DOMElement).html() == "") {
                    window.location.reload();
                }
            }

        });
    },

    notify: function () {
        $(".concurrent_users_notification").removeClass('hidden');
        $("html, body").animate({scrollTop: 0});
    },

    hide: function () { $(".concurrent_users_notification").addClass('hidden'); }

};

module.exports = ConcurrentUsers;